import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DashboardResponse } from "../../types/Dashboard.types";

type DashboardState = {
  data: DashboardResponse | null;
  loading: boolean;
  error: string | null;
};

const initialState: DashboardState = {
  data: null,
  loading: false,
  error: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchDashboardStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchDashboardSuccess: (state, action: PayloadAction<DashboardResponse>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchDashboardFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearDashboard: (state) => {
      state.data = null;
      state.error = null;
    },
  },
});

export const {
  fetchDashboardStart,
  fetchDashboardSuccess,
  fetchDashboardFailure,
  clearDashboard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
